/* Copyright (c) Trimble Inc. All rights reserved. */
import {Box, Button, CircularProgress, createStyles, DialogProps, makeStyles} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import NotificationActionsDialogComponents from "./NotificationActionsDialogComponents";
import { DropDownContainer } from "modus/components/form/dropdown-container/DropDownContainer";
import { IDropDownOption } from "modus/components/form/dropdown/Dropdown";
import { NotificationActionsProps } from "./TeamNotificationActions";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import SubscriptionApprovalServices from "../../services/SubscriptionApprovalService";
import { Alert } from "@material-ui/lab";
import { resolveAPIErrorMessage } from "modus/components/error-message/ErrorMessage";
import { useSelector } from "react-redux";
import { useCurrentTeam } from "libs/security/authorization/Permission";
import SubscriptionNotificationForm from "./SubscriptionForm";

export const ApproveSubscription: React.FC<NotificationActionsProps> = ({
  notification,
  refreshApprovals
}) => {
  const [open, setOpen] = React.useState(false);

  const useStyles = makeStyles(() => {
    return createStyles({
      header: {
        position: "relative",
      },
      dialog: {
        overflowX: "hidden",
      },
    });
  });

  const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(false);
  };
  const { teamId: storedTeamId } = useCurrentTeam();
  const teamId = useSelector((state: any) =>state?.teamManager?.teams?.currentTeam?.id ??storedTeamId);
  
  const { state, subscribe } = useAsyncAction(() =>
    SubscriptionApprovalServices.approveSubscriptionRequest(notification?.resource?.id)
  );

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (state?.status !== "LOADING" && state?.status !== "LOADED") {
      subscribe();
    }
    
  };

  useEffect(() => {
    if (state?.loaded && state?.value) {
      setTimeout(() => {

        refreshApprovals && refreshApprovals();
        setOpen(false);
      }, 3000);
    }
  },[refreshApprovals,state?.loaded, state?.value]);

  const [maxWidth] = useState<DialogProps["maxWidth"]>("sm");
  const style = useStyles();

  return (
    <>
      <Button color="primary" variant="outlined" onClick={handleClickOpen}>
        Approve
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation()}
        classes={{
          paper: style.dialog,
        }}
      >
        <DialogTitle>
            Subscription Request Review
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {state?.error && state?.status === "LOADED" && (
            <Alert severity="error">
              {resolveAPIErrorMessage(state?.error)}
            </Alert>
          )}
          {!state?.error && state?.status === "LOADED" && (
            <Alert severity="success">Given Application is now subscribed to the product.</Alert>
          )}
          <SubscriptionNotificationForm notification={notification} refreshApprovals={refreshApprovals} />
          
        </DialogContent>
        <DialogActions>
          <Box p={2}>
            <Button
              disabled={state?.loading}
              onClick={handleSubmit} color="primary" variant="contained">
                {state?.loading && <CircularProgress className="action-loader" />}
              Approve
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ApproveSubscription;
